/* eslint-disable jira/filename-case */
import { UNSAFE_initIfNeeded } from '@jira/platform__utils-feature-gates-unsafe-init/src/index.tsx';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

export function getCookieCircuitBreakerKillswitch(): number | null {
	// This function is not called on SSR.
	if (__SERVER__) {
		return null;
	}
	UNSAFE_initIfNeeded();
	/*
	 * not using the util because:
	 * - this is a dynamic config
	 * - only evaluated once per full page load, so cache is not needed
	 * - never evaluated on SSR, so no need for deferring __SSR_SYNC_READ_EXP_VAL__
	 *   instead of initing flags
	 */
	// eslint-disable-next-line jira/ff/use-recommended-utils
	const value = FeatureGates.getExperimentValue<number>('cookie-cb-reset', 'value', 0, {
		fireExperimentExposure: false,
	});

	if (value && Number.isFinite(value)) {
		return value;
	}

	return null;
}
